import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function ThankYouSection() {
  return (
    <section data-testid="thanks-section" className="bg-[var(--bone)] py-24 md:py-32 overflow-hidden">
      <div className="container-x grid grid-cols-12 gap-8 items-center">
        {/* Photo */}
        <div className="col-span-12 md:col-span-7 relative">
          <div className="relative">
            <div className="absolute -inset-3 md:-inset-5 bg-[var(--terracotta)]/15 -z-0 rotate-[-1.5deg]" />
            <div className="absolute -inset-1 md:-inset-2 bg-[var(--forest)] -z-0 rotate-[1deg]" />
            <div className="relative overflow-hidden">
              <img
                src="/community-thanks.png"
                alt="Children of an Ibadan school holding a handwritten Thank you Irene Foundation sign"
                className="w-full h-auto block"
              />
            </div>
            <div className="hidden md:block absolute -right-6 -bottom-6 bg-[var(--ink)] text-[var(--bone)] p-5 max-w-[280px] shadow-2xl">
              <div className="overline text-[var(--terracotta)]">Field report · 2024</div>
              <p className="font-serif text-lg mt-2 leading-snug">A handmade sign. Fifty-five children. One unforgettable morning.</p>
            </div>
          </div>
        </div>

        {/* Text */}
        <div className="col-span-12 md:col-span-5">
          <div className="overline text-[var(--terracotta)]">The moment that started it</div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl mt-5 leading-[1.0] tracking-[-0.025em]">
            New TVs, books, uniforms, pens — and a <em className="text-[var(--terracotta)] not-italic">handmade thank-you</em> we didn&apos;t expect.
          </h2>
          <p className="text-[var(--ink)]/75 mt-6 leading-relaxed">
            On a Tuesday morning in Ibadan, fifty-five children walked out of their newly
            equipped classroom holding a sign they had made themselves. We came to deliver
            books, uniforms, a television, and basic supplies. They reminded us why this
            work is, and always will be, about people.
          </p>
          <div className="mt-10">
            <div className="overline text-[var(--muted)]">Students reached that day</div>
            <div className="font-serif text-6xl mt-2 tracking-[-0.02em] text-[var(--ink)]">55</div>
          </div>
          <Link to="/volunteer" data-testid="thanks-volunteer-cta" className="btn-primary mt-10">
            Be part of the next one <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
